var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"icon":"fad fa-tools","title":"Typy oprav"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('PrimaryLinkButton',{attrs:{"to":"/setup/repair_types/create","icon":"fad fa-plus-circle","text":"Přidat typ opravy"}})]},proxy:true}])}),_c('RepairTypesList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }